module.exports = __webpack_public_path__ + "img/pc-who-are-we-pic2.07819db4.png";